import React, { Component } from 'react'
import { MiniLogo } from './logo'

class LifestyleIndex extends Component {

  render() {
    const { title, data } = this.props

    return (
      <div className='sp__lifestyle' id="lifestyle-index">
        <div className='single-suburb__inner'>
          <h4>{title}</h4>
          <h5>Lifestyle Index</h5>
          <div className='sp__lifestyle-wrapper'>
            <div className='sp__lifestyle-index'>
              <div className='sp__lifestyle-value'>
                <MiniLogo color={'#64656A'} />
                <span>{data.wpSuburb.acf.value}</span>
              </div>
              <div className='sp__lifestyle-content' dangerouslySetInnerHTML={{ __html: data.wpSuburb.acf.content }} />
            </div>
            <div className='sp__lifestyle-table'>
              <ul>
                <li>
                  <span>Parks</span>
                  <span>{data.wpSuburb.acf.parks}</span>
                </li>
                <li>
                  <span>Beaches</span>
                  <span>{data.wpSuburb.acf.beaches}</span>
                </li>
                <li>
                  <span>Schools</span>
                  <span>{data.wpSuburb.acf.schools}</span>
                </li>
                <li>
                  <span>Gyms</span>
                  <span>{data.wpSuburb.acf.gyms}</span>
                </li>
                <li>
                  <span>Health &amp; Beauty</span>
                  <span>{data.wpSuburb.acf.healthBeauty}</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span>Cafes</span>
                  <span>{data.wpSuburb.acf.cafes}</span>
                </li>
                <li>
                  <span>Restaurants</span>
                  <span>{data.wpSuburb.acf.restaurants}</span>
                </li>
                <li>
                  <span>Local Food</span>
                  <span>{data.wpSuburb.acf.localFood}</span>
                </li>
                <li>
                  <span>Culture</span>
                  <span>{data.wpSuburb.acf.culture}</span>
                </li>
                <li>
                  <span>Cinemas</span>
                  <span>{data.wpSuburb.acf.cinemas}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LifestyleIndex